export default __webpack_public_path__ + "images/528aaee4f188e7e43ac15978e23e3002.svg";